import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Col, Modal, Row } from 'antd'
import Button from 'components/Button'
import React from 'react'
export default function NotificationModal({
  isEditModal,
  handleEditConfirm,
  isConfirmLoading,
  handleEditClose,
}) {
  return (
    <Modal
      zIndex={'1001'}
      // visible={visible}
      open={isEditModal}
      onCancel={handleEditClose}
      centered
      footer={null}
      maskClosable={false}
      closable={false}
      bodyStyle={{
        borderRadius: '20px',
        padding: '32px 20px 32px 20px',
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <span
          style={{
            fontWeight: 600,
            lineHeight: '28px',
            fontSize: '18px',
            marginBottom: '30px',
            color: '#4B465C',
          }}
        >
          <ExclamationCircleOutlined
            style={{ color: 'red', marginRight: '10px' }}
          />
          Notification
        </span>
        <div
          style={{
            fontWeight: 400,
            lineHeight: '25px',
            fontSize: '16px',
            color: '#4D566E',
            marginTop: '10px',
          }}
        >
          Are you sure you want to update the application date to the already
          published role?
        </div>
      </div>
      <br></br>

      <Row gutter={24} justify={'center'} align={'middle'}>
        <Col>
          <Button.Secondary text="Back to Edit" onClick={handleEditClose} />
        </Col>
        <Col>
          <Button.Primary
            text={'Confirm'}
            loading={isConfirmLoading}
            onClick={handleEditConfirm}
          />
        </Col>
      </Row>
    </Modal>
  )
}
